const type = 'SET_CUSTOMER_PHONES_HISTORY';

const setCustomerPhonesHistory = (data) => ({
  data,
  type,
});

export { type };
export default setCustomerPhonesHistory;
